/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Sire_DetailInputs */



/**
* | output |
* | --- |
* | "The Ship Inspection Report Exchange (SIRE) is OCIMF's tanker vetting programme. SIRE 2.0 is the enhanced, risk-based version: it draws on the vessel, its cre..." |
*
* @param {Service_Sire_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_sire_detail = /** @type {((inputs?: Service_Sire_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Sire_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("船舶检查报告交换（SIRE）是 OCIMF 的油轮审查项目。SIRE 2.0 是其强化的、基于风险的版本：它综合考察船舶、船员和管理，使用基于平板电脑的数字化问卷并附照片佐证，生成更有针对性的报告。我们的认证检查员登轮检查，对照问卷库核实船舶状况与合规情况，并将报告提交至 OCIMF 数据库。")
	return /** @type {LocalizedString} */ ("The Ship Inspection Report Exchange (SIRE) is OCIMF's tanker vetting programme. SIRE 2.0 is the enhanced, risk-based version: it draws on the vessel, its crew and its management, uses a digital tablet-based question set with supporting photographs, and produces a more focused report. Our accredited inspectors attend the vessel, verify condition and compliance against the question library, and submit the report to the OCIMF database.")
});